import { createSlice } from '@reduxjs/toolkit'
import type { PayloadAction } from '@reduxjs/toolkit'

interface PopupStateProps {
  isOpened: boolean
}

const initialState: PopupStateProps = {
  isOpened: false,
}

export const popupSlice = createSlice({
  name: 'Popup',
  initialState,
  reducers: {
    openPopup: (state: PopupStateProps) => {
      state.isOpened = true
    },
    togglePopup: (state: PopupStateProps, action: PayloadAction<boolean>) => {
      state.isOpened = action.payload
    },
    clearPopup: (state: PopupStateProps) => {
      state.isOpened = false
    },
  },
})

export const { openPopup, togglePopup, clearPopup } = popupSlice.actions

export default popupSlice.reducer